import { createSelector } from '@ngrx/store';

import { orderTypesImagesState } from '../root';

export const getOrderTypeImages = createSelector(orderTypesImagesState, (orderTypesImages) => orderTypesImages);
